import { _ as r } from "../internals/export.js";
import { t } from "../internals/to-object.js";
import { l as e } from "../internals/length-of-array-like.js";
import { a as n } from "../internals/array-set-length.js";
import { d as a } from "../internals/does-not-exceed-safe-integer.js";
import { f as o } from "../internals/fails.js";
r({
  target: "Array",
  proto: !0,
  arity: 1,
  forced: o(function () {
    return 4294967297 !== [].push.call({
      length: 4294967296
    }, 1);
  }) || !function () {
    try {
      Object.defineProperty([], "length", {
        writable: !1
      }).push();
    } catch (r) {
      return r instanceof TypeError;
    }
  }()
}, {
  push: function push(r) {
    var o = t(this),
      s = e(o),
      i = arguments.length;
    a(s + i);
    for (var f = 0; f < i; f++) o[s] = arguments[f], s++;
    return n(o, s), s;
  }
});